




import { bookGoodsModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()
    },
)
